import { render, staticRenderFns } from "./OffersMatchingToSkillList.vue?vue&type=template&id=530a78fc&scoped=true&"
import script from "./OffersMatchingToSkillList.vue?vue&type=script&lang=js&"
export * from "./OffersMatchingToSkillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a78fc",
  null
  
)

export default component.exports